import { createAction, createReducer } from 'deox';

export interface AuthenticityToken {
  token: string | null;
}

const defaultState: AuthenticityToken = {
  token: null,
};

export const setAuthenticityToken = createAction(
  'SET_AUTHENTICITY_TOKEN',
  resolve => (token: string) => resolve(token),
);

export const authenticityTokenReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(setAuthenticityToken, (state, { payload: token }) => ({
      ...state,
      token,
    })),
  ],
);

interface MountedState {
  authenticityToken: AuthenticityToken;
}

export const selectAuthenticityToken = (state: MountedState): string => {
  if (!state.authenticityToken.token)
    throw new Error('Expect the authenticityToken to have been provided');

  return state.authenticityToken.token;
};

export default authenticityTokenReducer;
